export const colorToHTMLString = (text: string, color: string, fontWeight?: number): string => {
  return `<span style="color: ${color}; ${
    fontWeight ? `font-weight: ${fontWeight}` : ''
  }" >${text}</span>`
}
